/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementPreviewItemResponse } from './CarpsaleManagementPreviewItemResponse';

export type CarpsaleManagementPreviewItemResponseApiRespoonse = {
    data?: CarpsaleManagementPreviewItemResponse;
    status?: CarpsaleManagementPreviewItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementPreviewItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

